import { UserBookmarkCountBy } from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-by";
import { RouteUtils } from "./route-utils";
import { siteMap } from "internal-sitemap";
import UserBookmarkSortOption from "models/enumerations/sorting/user-bookmarks/user-bookmark-sort-option";
import CultureResources from "./interfaces/culture-resources";
import UserBookmarkShareFilterOption from "models/enumerations/filtering/user-bookmarks/user-bookmark-share-filter-option";
import { UserBookmarkColors } from "./enumerations/user-bookmark-colors";
import { CustomColorUtils } from "./custom-color-utils";
import { ColorSelectType } from "organisms/my-link/my-bookmarks/color-select";
import UserBookmarkCountSortOption from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-sort-option";

export enum ViewByGroup {
    All = "all",
    Publications = "publication",
    Collections = "collection",
    Color = "color",
}

export const BookmarkGroupNameFromCountByMap = {
    [UserBookmarkCountBy.Collection]: ViewByGroup.Collections,
    [UserBookmarkCountBy.Color]: ViewByGroup.Color,
    [UserBookmarkCountBy.Publication]: ViewByGroup.Publications,
    [UserBookmarkCountBy.All]: ViewByGroup.All,
};

export const UserBookmarkCountByFromGroupNameMap = {
    [ViewByGroup.Collections]: UserBookmarkCountBy.Collection,
    [ViewByGroup.Color]: UserBookmarkCountBy.Color,
    [ViewByGroup.Publications]: UserBookmarkCountBy.Publication,
    [ViewByGroup.All]: UserBookmarkCountBy.All,
};

export const SortByValueToNameMap: { [key: string]: keyof CultureResources } = {
    [UserBookmarkSortOption.BookOrder]: "bookOrder",
    [UserBookmarkSortOption.CreatedOnAscending]: "oldest",
    [UserBookmarkSortOption.CreatedOnDescending]: "newest",
};

export const CountSortByValueToNameMap: {
    [key: string]: keyof CultureResources;
} = {
    [UserBookmarkCountSortOption.BookmarkCreatedOnAscending]:
        "oldestBookmarkAdded",
    [UserBookmarkCountSortOption.BookmarkCreatedOnDescending]:
        "newestBookmarkAdded",
    [UserBookmarkCountSortOption.Collection]: "azByCollection",
    [UserBookmarkCountSortOption.BookOrder]: "bookOrder",
};

export const ShareFilterValueToNameMap: {
    [key: string]: keyof CultureResources;
} = {
    [UserBookmarkShareFilterOption.All]: "all",
    [UserBookmarkShareFilterOption.PrivateOnly]: "addedByMe",
};

const getViewByRoute = (countBy: UserBookmarkCountBy) => {
    return siteMap.myLink.myBookmarks.by[
        BookmarkGroupNameFromCountByMap[countBy]
    ];
};

const getColorClassName = (color: UserBookmarkColors) => {
    return CustomColorUtils.getClassModifier(
        UserBookmarkColors,
        color,
        ColorSelectType.Bookmark
    );
};

const getDetailViewRoute = (
    group: ViewByGroup,
    groupId: string | number,
    bookmarkId: number,
    searchParams: string = ""
) => {
    const routeToDetailPage = RouteUtils.replacePathParams(
        siteMap.myLink.myBookmarks.detail,
        {
            group,
            groupId,
            id: bookmarkId,
        }
    );
    return `${routeToDetailPage}${searchParams}`;
};

const buildGroupedParam = (
    groupId: UserBookmarkCountBy,
    id: string | number
) => {
    return `${groupId}_${id}`;
};

const getGroupingByPath = () => {
    let grouping = UserBookmarkCountBy.All;
    Object.values(ViewByGroup).forEach((groupName) => {
        if (RouteUtils.assertCurrentUrlContains(groupName))
            grouping = UserBookmarkCountByFromGroupNameMap[groupName];
    });
    return grouping;
};

export const BookmarkUtils = {
    buildGroupedParam,
    getDetailViewRoute,
    getColorClassName,
    getViewByRoute,
    getGroupingByPath,
};
